export const SCREEN_NAME = {
    CHECKOUT: "checkout",
    CUSTOMIZATION: "customization",
    COUPON_LISTING: "food-apply-coupon",
    GROUP_CART: "group-cart",
    GIFTING_APPLY_COUPON: "gifting-apply-coupon",
    GIFTING_CHECKOUT: "gifting-checkout",
    IRCTC_PNR_FLOW: "irctc_pnr_flow_screen",
    IRCTC_ADDRESS_CHANGE: "irctc_address_change",
    QUICK_CHECKOUT: "quick-checkout",
};
